import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { BASE_URL } from "../../../utils/BaseURL";
import axios from "axios";
import { enqueueSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
};

export default function EditAddressModal({ flag, setFlag, id }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { user } = JSON.parse(localStorage.getItem("user")) || {};
  const [formData, setFormData] = React.useState({
    name: "",
    mobile: "",
    pincode: "",
    locality: "",
    address: "",
    city: "",
    state: "",
    landmark: "",
    addressType: "",
    user: user._id,
  });

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    // console.log(user._id)
    if (
      !formData.address ||
      !formData.addressType ||
      !formData.mobile ||
      !formData.pincode ||
      !formData.state ||
      !formData.name
    ) {
      enqueueSnackbar("PLease Fill all the necessary fields", {
        variant: "error",
      });
      return;
    }

    axios
      .put(`${BASE_URL}/address/${id}`, formData)
      .then((res) => {
        if (res.data.success) {
          enqueueSnackbar("Address Updated Successfully", {
            variant: "success",
          });
          handleClose();
          setFlag(!flag);
        } else {
          enqueueSnackbar("Something went wrong", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, { variant: "error" });
      });
  };

  React.useEffect(() => {
    if (id) {
      axios.get(`${BASE_URL}/address/user/${id}`).then((res) => {
        const data = res?.data?.data;
        setFormData((prevData) => ({
          ...prevData,
          name: data?.name,
          mobile: data?.mobile,
          pincode: data?.pincode,
          locality: data?.locality,
          address: data?.address,
          city: data?.city,
          state: data?.state,
          landmark: data?.landmark,
          addressType: data?.addressType,
          user: user._id,
        }));
      });
    }
  }, [id]);

  return (
    <div>
      <Button
        size="small"
        variant="contained"
        color="success"
        onClick={handleOpen}
      >
        Edit
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className=" flex flex-col gap-5 ">
            <div>
              <form className="w-full max-w-lg mt-10">
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-first-name"
                    >
                      Full Name
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="name"
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="w-full md:w-1/2 px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-last-name"
                    >
                      Mobile
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="mobile"
                      type="text"
                      placeholder="10 digit mobile number"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-first-name"
                    >
                      Pincode
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="pincode"
                      type="text"
                      placeholder="Pincode"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="w-full md:w-1/2 px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-last-name"
                    >
                      Locality
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="locality"
                      type="text"
                      placeholder="Locality"
                      name="locality"
                      value={formData.locality}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Address (Area and Street)
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      name="address"
                      id="addresse"
                      class="resize-none border rounded w-full py-2 px-3 bg-gray-200 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      value={formData.address}
                      onChange={handleChangeInput}
                      rows="4"
                      placeholder="Type here..."
                    ></textarea>
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-2">
                  <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-city"
                    >
                      City
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="city"
                      type="text"
                      placeholder="Delhi"
                      name="city"
                      value={formData.city}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-state"
                    >
                      State
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="landmark"
                      type="text"
                      placeholder="landmark"
                      name="state"
                      value={formData.state}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-zip"
                    >
                      Landmark
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="landmark"
                      type="text"
                      placeholder="landmark"
                      name="landmark"
                      value={formData.landmark}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0 mt-10">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-zip"
                    >
                      Address Type
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className=" flex flex-col  space-x-2">
                      <RadioGroup
                        row
                        aria-label="address-type"
                        name="addressType"
                        defaultValue="home"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <Box display={"flex"}>
                          <FormControlLabel
                            value="home"
                            control={<Radio />}
                            label="Home"
                            checked={
                              formData?.addressType === "Home" ? true : false
                            }
                            onClick={() =>
                              setFormData({ ...formData, addressType: "Home" })
                            }
                          />
                          <FormControlLabel
                            value="work"
                            control={<Radio />}
                            label="Work"
                            onClick={() =>
                              setFormData({ ...formData, addressType: "Work" })
                            }
                            checked={
                              formData?.addressType === "Work" ? true : false
                            }
                          />
                        </Box>
                      </RadioGroup>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className=" flex gap-3">
              <button
                className=" bg-blue-500 text-center text-white px-16 py-3 rounded-md"
                onClick={handleSubmit}
              >
                Save
              </button>
              <button onClick={handleClose}>Cancel</button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
